import React from "react";
import styles from "./index.scss";
import NewLogo from '@/assets/logo-black.png';

type Props = {
  /** 提示文字，默认"加载中" */
  tip?: string;
  /** 占满整个视口（路由级加载用），默认 false 占满父容器 */
  fullscreen?: boolean;
};

/**
 * 通用加载组件
 * - 路由级：src/loading.tsx 直接复用（fullscreen）
 * - 局部：<PageLoading /> 占满父容器居中
 */
/** 品牌红圆环绕 logo，作为全局 Spin indicator（表格/局部 loading 统一视觉） */
export const SpinRing: React.FC = () => (
  <span className={styles.spinRing}>
    <span className={styles.spinRingBox}>
      <i className={styles.spinRingCircle} />
      <img src={NewLogo} alt="" />
    </span>
  </span>
);

const PageLoading: React.FC<Props> = ({ tip = '加载中', fullscreen = false }) => {
  return (
    <div className={fullscreen ? styles.pageLoadingFullscreen : styles.pageLoading}>
      <div className={styles.loadingBox}>
        <div className={styles.logoRing}>
          <img src={NewLogo} alt="" />
        </div>
        <div className={styles.loadingTip}>
          {tip}
          <span className={styles.loadingDots}>
            <i>.</i>
            <i>.</i>
            <i>.</i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageLoading;
